export default {
      id: "ic_refresh-usage",
      viewBox: "0 0 14 15",
      url: "/" + "images/icons.3.109.2.svg#ic_refresh-usage",
      toString: function () {
        return this.url;
      }
    }